import { useEffect, useState } from "react";
import api from "../../services/api";
import { useAuth } from "../../contexts/AuthContext";

const MAX_ROUNDS = 8; // the server analyses old sessions 25 at a time

/**
 * Rows for the Progress page (#203) from GET /api/sessions/analysis, or [].
 * The first visit after this shipped asks again while the server still has
 * older sessions to analyse, so the curve fills in rather than waiting for a
 * reload. `loading` is true until the first answer.
 */
export default function useSessionAnalysis() {
  const { isAuthenticated } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(isAuthenticated);
  useEffect(() => {
    if (!isAuthenticated) {
      setRows([]);
      setLoading(false);
      return undefined;
    }
    let live = true;
    const load = async (round) => {
      try {
        const res = await api.getSessionAnalysis();
        if (!live) return;
        setRows(Array.isArray(res?.sessions) ? res.sessions : []);
        setLoading(false);
        if (res?.pending > 0 && round < MAX_ROUNDS) load(round + 1);
      } catch {
        if (live) setLoading(false);
      }
    };
    load(1);
    return () => {
      live = false;
    };
  }, [isAuthenticated]);
  return { rows, loading };
}
